import React from 'react';

const GalleryAddIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      {...props}
    >
      <path
        d="M13.1276 14.5833C14.7384 14.5833 16.0443 13.2775 16.0443 11.6667C16.0443 10.0558 14.7384 8.75 13.1276 8.75C11.5168 8.75 10.2109 10.0558 10.2109 11.6667C10.2109 13.2775 11.5168 14.5833 13.1276 14.5833Z"
        stroke="currentColor"
        strokeWidth="2.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9557 2.91699H13.1224C5.83073 2.91699 2.91406 5.83366 2.91406 13.1253V21.8753C2.91406 29.167 5.83073 32.0837 13.1224 32.0837H21.8724C29.1641 32.0837 32.0807 29.167 32.0807 21.8753V14.5837"
        stroke="currentColor"
        strokeWidth="2.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9688 7.29199H30.9896"
        stroke="currentColor"
        strokeWidth="2.1875"
        strokeLinecap="round"
      />
      <path
        d="M26.9766 11.3021V3.28125"
        stroke="currentColor"
        strokeWidth="2.1875"
        strokeLinecap="round"
      />
      <path
        d="M3.89453 27.6337L11.0841 22.8066C12.2362 22.0337 13.8987 22.1212 14.9341 23.0108L15.4154 23.4337C16.5529 24.4108 18.3904 24.4108 19.5279 23.4337L25.5945 18.2274C26.732 17.2504 28.5695 17.2504 29.707 18.2274L32.0841 20.2691"
        stroke="currentColor"
        strokeWidth="2.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GalleryAddIcon;
